import React from "react";
import "./Passbook.css";
import { Helmet } from "react-helmet";
import Sidebar from "../Sidebar";
import DeshBoardFooter from "../DeshBoardFooter";
import { useAuth } from "../../../Store/AuthContext";
import DeshbordBreadcrumb from "../Breadcrumb/DeshbordBreadcrumb";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
// import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { Link } from "react-router-dom";
import PassbookTransactionDataTable from "./PassbookTransactionDataTable";

export default function Passbook() {
  const { RendomTokenfetch, walletbalance } = useAuth();

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <Sidebar />
        <DeshbordBreadcrumb page1={[{ name: "Passbook" }]} />
        <section className="user-dashboard">
          <div className="dashboard-outer">
            <div
              className="newspapermultyupdatebox"
              style={{ borderBottom: "unset" }}
            >
              <div className="row my-1">
                <div className="col-lg-12 col-md-12 text-end mt-1">
                  <Link
                    to="/add-wallet"
                    className="theme-btn btn-style-three submitbtn handleServiceStatus"
                  >
                    <span>
                      <i className="fa fa-plus me-2"></i>
                    </span>{" "}
                    Add Wallet
                  </Link>
                  <Link
                    to="/wallet-transactions"
                    className="mx-3 theme-btn btn-style-three submitbtn handleServiceStatus"
                  >
                    <span>
                      <i className="fa fa-info me-2"></i>
                    </span>{" "}
                    Transactons
                  </Link>
                  <Link
                    to="/withdrawal-amount"
                    className="theme-btn btn-style-three submitbtn handleServiceStatus"
                  >
                    <span>
                      <i className="fa fa-money me-2"></i>
                    </span>{" "}
                    Withdrawal
                  </Link>
                </div>
              </div>
            </div>
            <div className="wallet-container">
              <div className="wallet-header ">
                <div className="tabs">
                  <button className="tab active">
                    <span className="wallettabicon">
                      <AccountBalanceWalletOutlinedIcon />
                    </span>{" "}
                    {/* <span className="wallettabText">
                      <span className="walletHeading">WALLET</span>
                      <span className="text-left walletAmount">
                        ₹{walletbalance ? walletbalance : "0"}
                      </span>
                    </span> */}
                  </button>
                </div>
                <div className="balance-section">
                  <h2>TOTAL BALANCE</h2>
                  <div className="balance-amount">
                    ₹{walletbalance ? walletbalance : "0"}
                  </div>
                </div>
              </div>
              {RendomTokenfetch && <PassbookTransactionDataTable />}
            </div>
          </div>
        </section>

        <div className="deshboard_footer">
          <DeshBoardFooter RendomTokenfetch={RendomTokenfetch} />
        </div>
      </div>
    </>
  );
}
